<template>
  <div class="wrapper">
    <side-bar :title="prefix">
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'หน้าแรก',
            icon: 'fas fa-tachometer-alt',
            path: '/dashboard',
          }"
        />
        <sidebar-item
          :link="{
            name: 'รายการสมาชิก',
            icon: 'fas fa-users',
            path: '/dashboard/members',
          }"
          v-if="hasPermission('manage.members')"
        />
        <sidebar-item
          :link="{
            name: 'แก้ไขรายการ',
            icon: 'fas fa-edit',
            path: '/dashboard/fix-tx',
          }"
          v-if="hasPermission('manage.fixTx')"
        />
        <sidebar-item
          :link="{
            name: 'รายการฝาก / ถอน',
            icon: 'fas fa-university',
          }"
        >
          <sidebar-item
            :link="{
              name: 'รายการฝาก',
              path: '/dashboard/deposit',
            }"
            v-if="hasPermission('manage.deposit')"
          />
          <sidebar-item
            :link="{
              name: 'รายการถอน',
              path: '/dashboard/withdraw',
            }"
            v-if="hasPermission('manage.withdraw')"
          />
          <sidebar-item
            :link="{
              name: 'รายการเงินเข้า',
              path: '/dashboard/bank-transactions',
            }"
          />
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'โปรโมชั่น', icon: 'fas fa-gift' }"
          v-if="
            hasPermission('manage.bonus') ||
            hasPermission('manage.wheel') ||
            hasPermission('manage.redeem')
          "
        >
          <sidebar-item
            :link="{
              name: 'โบนัสทั่วไป',
              path: '/dashboard/promotion/bonus',
            }"
          />
          <sidebar-item
            :link="{
              name: 'แจกเครดิต (สมาชิกใหม่)',
              path: '/dashboard/promotion/new-reg-bonus',
            }"
          />
          <sidebar-item
            :link="{
              name: 'กงล้อเสี่ยงโชค',
              path: '/dashboard/wheel',
            }"
            v-if="hasFeature('wheel') && hasPermission('manage.wheel')"
          />
          <sidebar-item
            :link="{
              name: 'โค๊ดโปรโมชั่น',
              path: '/dashboard/promotion/redeem',
            }"
            v-if="hasFeature('redeem') && hasPermission('manage.redeem')"
          />
          <sidebar-item
            :link="{
              name: 'คืนยอดเสีย (Cashback)',
              path: '/dashboard/promotion/cashback',
            }"
            v-if="hasFeature('cashback')"
          />
          <sidebar-item
            :link="{
              name: 'แนะนำเพื่อน (Affiliate)',
              path: '/dashboard/promotion/affiliate',
            }"
          />
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'กราฟ', icon: 'fas fa-chart-pie' }"
          v-if="hasPermission('manage.summary')"
        >
          <sidebar-item
            :link="{
              name: 'รายการฝาก',
              path: '/dashboard/summary/deposit',
            }"
          />
          <sidebar-item
            :link="{
              name: 'รายการถอน',
              path: '/dashboard/summary/withdraw',
            }"
          />
          <sidebar-item
            :link="{
              name: 'รายการสมัครสมาชิก',
              path: '/dashboard/summary/register',
            }"
          />
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'รายงานสรุป', icon: 'fas fa-list' }"
          v-if="hasPermission('manage.summary')"
        >
          <sidebar-item
            :link="{
              name: 'รายงานโบนัส',
              path: '/dashboard/summary/bonus',
            }"
          />
          <sidebar-item
            :link="{
              name: 'รายงานโค๊ดโปรโมชั่น',
              path: '/dashboard/summary/redeem',
            }"
          />
          <sidebar-item
            :link="{
              name: 'รายงานกงล้อเสี่ยงโชค',
              path: '/dashboard/summary/wheel',
            }"
          />
          <sidebar-item
            :link="{
              name: 'รายงานแคชแบ็ก',
              path: '/dashboard/summary/cashback',
            }"
          />
          <sidebar-item
            :link="{
              name: 'รายงานแนะนำเพื่อน',
              path: '/dashboard/summary/affiliate',
            }"
          />
          <sidebar-item
            :link="{
              name: 'รายงานฝาก/ถอนรายบุคคล',
              path: '/dashboard/summary/report-by-member',
            }"
          />
          <sidebar-item
            :link="{
              name: 'สรุปข้อมูล',
              path: '/dashboard/summary',
            }"
          />
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'ธนาคาร', icon: 'fas fa-university' }"
          v-if="hasPermission('manage.bank')"
        >
          <sidebar-item
            :link="{
              name: 'ตั้งค่าธนาคาร',
              path: '/dashboard/bank',
            }"
          />
          <sidebar-item
            :link="{
              name: 'SCB API',
              path: '/dashboard/scb',
            }"
            v-if="hasFeature('scbDeposit') || hasFeature('scbWithdraw')"
          />
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'รายการแอดมิน',
            icon: 'fas fa-users',
            path: '/dashboard/users',
          }"
          v-if="hasPermission('manage.users')"
        />
        <sidebar-item
          :link="{
            name: 'เว็บไซต์',
            icon: 'fas fa-cogs',
            path: '/dashboard/setting',
          }"
          v-if="hasPermission('manage.website')"
        />
        <sidebar-item
          :link="{
            name: 'บันทึกกิจกรรม',
            icon: 'fas fa-terminal',
            path: '/dashboard/log',
          }"
          v-if="hasPermission('manage.website')"
        />
        <li class="nav-item">
          <a href="https://kb.msn.bet" target="_blank" class="nav-link">
            <i class="fas fa-book" />
            <span class="nav-link-text">คู่มือการใช้งาน</span>
          </a>
        </li>
      </template>
    </side-bar>

    <div class="main-content">
      <base-nav
        container-classes="container-fluid"
        class="navbar-top border-bottom navbar-expand navbar-dark bg-dark"
      >
        <ul class="navbar-nav align-items-center ml-md-auto">
          <li class="nav-item d-xl-none">
            <div class="pr-3 sidenav-toggler" @click="toggleSidebar">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line" />
                <i class="sidenav-toggler-line" />
                <i class="sidenav-toggler-line" />
              </div>
            </div>
          </li>
        </ul>
        <ul class="navbar-nav align-items-center ml-auto ml-md-0">
          <base-dropdown
            class="nav-item"
            tag="li"
            title-tag="a"
            title-classes="nav-link pr-0"
            :title="prefix"
            menu-on-right
          >
            <template>
              <button class="dropdown-item" @click="triggerLogout">
                <i class="fas fa-sign-out-alt" />
                <span>ออกจากระบบ</span>
              </button>
            </template>
          </base-dropdown>
        </ul>
      </base-nav>

      <div class="content">
        <div class="container-fluid mt-4">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { API_ENDPOINT } from "../../services";
import AuthService from "../../services/auth.service";

const audio = new Audio(require("../../assets/noti.mp3"));

export default {
  data() {
    return {
      prefix: localStorage.getItem("x-prefix"),
      socket: null,
      pinger: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["hasPermission", "hasFeature"]),
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    triggerLogout() {
      if (this.socket) {
        this.socket.close();
      }

      localStorage.removeItem("x-backend-auth");
      this.$router.push("/login");
    },
    connectWebSocket(endPoint) {
      if (this.socket != null) {
        return false;
      }

      const prefix = localStorage.getItem("x-prefix");
      const token = localStorage.getItem("x-backend-auth");
      const socket = new WebSocket(
        `${endPoint}/ws?prefix=${prefix}&token=${token}`
      );
      this.socket = socket;

      socket.onclose = (e) => {
        this.socket = null;
      };
      socket.onmessage = (msg) => {
        if (msg.data !== "PONG") {
          const notify = JSON.parse(msg.data);
          audio.currentTime = 0;
          audio.volume = 0.5;
          audio.play();
          this.$notify({
            type: notify.Type,
            message: notify.Message,
            timeout: 5000,
          });
        }
      };
    },
  },
  created() {
    const token = localStorage.getItem("x-backend-auth");
    const endPoint = API_ENDPOINT.replace("http://", "ws://").replace(
      "https://",
      "wss://"
    );
    if (token) {
      this.connectWebSocket(endPoint);
      // this.pinger = setInterval(() => {
      //   if (this.socket) {
      //     this.socket.send("PING");
      //   }
      // }, 5000);
    }
  },
  destroyed() {
    if (this.pinger) {
      clearInterval(this.pinger);
    }
  },
};
</script>

<style lang="scss" scoped>
.sidenav-toggler-line {
  background-color: #fff;
}
</style>
